import { MinhaAgendaService } from '../../../../../services/minha-agenda.service';
import { MinhaAgenda } from '@app/models/minha-agenda';
import { Component, Inject, OnInit, } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MeAvise } from '@app/models/me-avise';
import { TipoMovimentacao } from '@app/models/processo-movimentacao';
import { ConsultasService } from '@app/services/consultas.service';
import { IdDescricao } from '@app/models/util/id-descricao';
import { ProcessoService } from '@app/services/processo.service';
import { ToastrService } from 'ngx-toastr';
import { ProcessoMovimentacaoService } from '@app/services/processo-movimentacao.service';


@Component({
  selector: 'app-movimentacao-meavise-form',
  templateUrl: './movimentacao-meavise-form.component.html'
})
export class MovimentacaoMeAviseFormComponent implements OnInit {

  titulo: string;
  titulo2: string;
  meAvise: MeAvise[] = [];
  aguardandoSolicitacao: boolean = false;
  lstErros: string[];
  lstUsuarios: IdDescricao[];
  lstMeAviseTipo: IdDescricao[];
  editar = false;
  tipo: string;
  tipoMovimentacao: TipoMovimentacao;
  descricaoMovimentacao;
  index: number = 0;
  meAviseSucesso: number[] = [];

  processoId: number;
  movimentacaoId: number;

  agenda: MinhaAgenda = new MinhaAgenda();  
  processoArquivado: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private processoService: ProcessoService,
    private processoMovimentacaoService: ProcessoMovimentacaoService,
    private consultasService: ConsultasService,
    private minhaAgendaService: MinhaAgendaService,
    @Inject(ToastrService) public toastr: ToastrService
  ) { }

  ngOnInit() {

    this.consultasService.consultar('USUARIO_APELIDO').subscribe(data => this.lstUsuarios = data);
    this.consultasService.consultar('MEAVISETIPO').subscribe(data => this.lstMeAviseTipo = data);
    // this.agenda = new MinhaAgenda();

    this.route.parent.params.subscribe(
      (params: any) => {
        this.processoId = params['id'];
      });

    this.route.params.subscribe(params => {
      this.tipo = params['tipo'];
      switch (this.tipo.toUpperCase()) {
        case 'ADMINISTRATIVA':
          this.titulo = 'Movimentação Administrativa';
          this.tipoMovimentacao = TipoMovimentacao.ADMINISTRATIVA;
          break;
        case 'EXECUCAO-PROVISORIA':
          this.titulo = 'Movimentação Execução Provisória';
          this.tipoMovimentacao = TipoMovimentacao.EXECUCAO_PROVISORIA;
          break;
        case 'JUDICIAL':
          this.titulo = 'Movimentação Judicial';
          this.tipoMovimentacao = TipoMovimentacao.JUDICIAL;
          break;
        default:
          this.tipoMovimentacao = null;
      }
    });

    this.route.params.subscribe(params => {
      const id = params['meaviseid'];
      this.titulo2 = id ? 'Editar Me Avise' : 'Novo Me Avise';

      if (!id) {
        this.movimentacaoId = params['movid'];
      } else {
        this.editar = true;

        this.processoService.movimentacaoObterMeAvise(id).subscribe(
          data => {
            this.meAvise = [];
            this.meAvise.push(data);
            this.meAvise[0].Data = this.meAvise[0].Data.split('T')[0];
            this.meAvise[0].Prazo = this.meAvise[0].Prazo?.split('T')[0];
            this.buscarMovimentacao();
          },
          () => this.router.navigate(['./processo/buscar-processos']));
      }

      this.meAvise.push(new MeAvise());
      if (!this.editar) {
        this.meAvise[0].ProcessoId = this.processoId;
        this.meAvise[0].ProcessoMovimentacaoId = this.movimentacaoId;
        this.buscarMovimentacao();
      }
    });
  }

  recebeTamanho(i){
    this.index = i - 1;
  }

  onSubmit() {
    for (var i = 0; i <= this.index; i++) {
      if (i !== 0) {
        this.meAvise[i].ProcessoId = this.processoId;
        if (!this.editar) {
          this.meAvise[i].ProcessoMovimentacaoId = this.movimentacaoId;
        }
      }
      // shawdowed variable
      const meAviseSelecionado = this.meAvise[i];
      const indexLocal = i;
      // let agenda = this.lstAgenda[0];
      this.aguardandoSolicitacao = true;
      if (meAviseSelecionado.Agenda) {
        this.agenda.Descricao = meAviseSelecionado.Descricao;
        this.agenda.HoraInicioAgendada = meAviseSelecionado.HorarioAgenda;
        this.agenda.UsuarioId = meAviseSelecionado.UsuarioAtualId;
        this.agenda.DataAgendada = meAviseSelecionado.Data;
        this.agenda.ProcessoId = meAviseSelecionado.ProcessoId;
        this.agenda.ProcessoMovimentacaoId = meAviseSelecionado.ProcessoMovimentacaoId;

        this.minhaAgendaService.gravar(this.agenda).toPromise().then(
          // (data: any) => {
          //   if (data.error)
          //     this.lstErros = data.error.errors;
          // }
        );
      }

      if (!this.meAviseSucesso.includes(i)) {
        this.processoService.movimentacaoGravarMeAvise(meAviseSelecionado).toPromise().then(
          () => {
            //this.toastr.success(meAviseSelecionado.Descricao, 'Criado com sucesso');
            this.meAviseSucesso.push(indexLocal);
          },
          (data: any) => {
            this.lstErros = data.error?.errors;
            this.aguardandoSolicitacao = false;
          }
        ).finally(
          () => {
            if (this.meAviseSucesso.length === this.meAvise.length) {
              window.history.go(-1);
              this.meAvise = [];
            }
          }
        );
      }
    }
  }

  buscarMovimentacao() {
    const meAvise = this.meAvise[0];
    this.processoMovimentacaoService
      .obterDescricaoMovimentacaoPorId(meAvise.ProcessoMovimentacaoId)
      .subscribe(data => { this.descricaoMovimentacao = data; });
  }
}
